import utils from "axios/lib/utils";
import settle from "axios/lib/core/settle";
import buildURL from "axios/lib/helpers/buildURL";
import combineURLs from "axios/lib/helpers/combineURLs";
import isAbsoluteURL from "axios/lib/helpers/isAbsoluteURL";

/**
 * Resolves the request URL the same way axios would before the native HTTP plugin runs.
 *
 * @param {import('axios').AxiosRequestConfig} requestConfig
 * @returns {string}
 */
function resolveRequestUrl(requestConfig) {
    let { url, baseURL } = requestConfig;
    if (!url) {
        return baseURL || "";
    }
    if (!isAbsoluteURL(url)) {
        url = combineURLs(baseURL, url);
    }
    return buildURL(url, requestConfig.params, requestConfig.paramsSerializer);
}

/**
 * @param {string|object} body
 * @returns {object|string}
 */
function parseResponseBody(body) {
    if (typeof body !== "string") {
        return body;
    }
    try {
        return JSON.parse(body);
    } catch (e) {
        return body;
    }
}

export default function cordovaAdapter(config) {
    return new Promise((resolve, reject) => {
        const requestData = config.data;
        const requestHeaders = config.headers;

        if (utils.isFormData(requestData)) {
            delete requestHeaders["Content-Type"]; // Let the browser set it
        }

        if (window.cordova && window.cordova.plugin.http) {
            const requestUrl = resolveRequestUrl(config);
            const requestCordova = {
                method: config.method,
                data: config.data,
                serializer: "utf8",
                timeout: config.timeout,
                headers: JSON.parse(JSON.stringify(requestHeaders)),
            };
            try {
                window.cordova.plugin.http.sendRequest(
                    requestUrl,
                    requestCordova,
                    (response) => {
                        const responseAxios = {
                            data: parseResponseBody(response.data),
                            status: response.status,
                            statusText: "ok",
                            config,
                            request: requestCordova,
                            headers: response.headers,
                        };
                        settle(resolve, reject, responseAxios);
                    },
                    (response) => {
                        const responseAxios = {
                            data: parseResponseBody(response.error),
                            status: response.status,
                            config,
                            headers: response.headers,
                        };
                        settle(resolve, reject, responseAxios);
                    },
                );
            } catch (error) {
                reject(error);
            }
            return;
        }

        reject(new Error("Cordova HTTP plugin is not available"));
    });
}
